import styled from "styled-components";
import { colors, spacing } from "design-system/foundation";
import { breakpoints } from "styles";

export const SessionWrapper = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  justify-content: center;
  min-height: calc(100vh - 80px);

  @media ${breakpoints.tablet} {
    height: calc(100vh - 80px);
    overflow: hidden;
    align-items: stretch;
    padding: ${spacing["8xl"]} ${spacing.none};
    background:
      url("/assets-v2/illustrations/background_practice.svg") center / cover
        no-repeat,
      radial-gradient(
        circle,
        ${colors.bg.brand.primaryBold},
        ${colors.bg.base.secondary}
      );
  }
`;
